function regexValidUrl(text: any) {
    if (text && text !== "") {
        // eslint-disable-next-line no-control-regex
        // let reg = new RegExp('^(http|https)://')
        // return reg.test(text)
        return text.startsWith("http://") || text.startsWith("https://")
    }
    return true
}

function isValidSimpleAlphanumeric(input: any) {
    let regex = /^[a-zA-Z0-9_/-]*$/i;
    return regex.test(input);
}

function testDomainValidity(urlString: string) {

    function testHostname(url: URL) {
        // Hostname validation
        const hostname = url.hostname;

        // Must have TLD unless IP address
        if (!hostname.includes('.') && !/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) {
            return false;
        }

        // Validate each part of hostname
        const parts = hostname.split('.');
        const tld = parts[parts.length - 1];

        // TLD must be at least 2 chars (unless IP)
        if (!/^\d+$/.test(tld) && tld.length < 2) {
            return false;
        }

        // Check each domain label
        for (const part of parts) {
            if (part.length === 0) {
                return false; // Empty part (consecutive dots)
            }
            if (part.startsWith('-') || part.endsWith('-')) {
                return false; // Can't start/end with hyphen
            }
            if (!/^[a-zA-Z0-9-]+$/.test(part)) {
                return false; // Invalid characters
            }
        }

        const tldPattern = /^\/\.(com|org|net|io|co|uk|de|fr|jp|cn|info|biz|gov|edu|mil|int|eu|ch|au|us|ca|mx|br|ar|in|ru|za|sg|hk|tw|kr|ai|app|dev|tech|xyz|online|store|shop|cloud|digital|[a-z]{2,6})($|\/|\?|#)/i;

        return !tldPattern.test(url.pathname);
    }

    let _url = urlString;

    try {
        // Add protocol https:// by default if not present
        if (!(urlString.includes("http:") || urlString.includes("https:"))) _url = "https://" + urlString;
        // Convert to readable URL
        const url = new URL(_url);
        // Check hostname validity
        if (!testHostname(url)) return false
    } catch (e) {
        return false
    }

    const pattern = new RegExp(
        '^([a-zA-Z]+:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', // fragment locator
        'i'
    );
    return pattern.test(_url);
}


export {regexValidUrl, isValidSimpleAlphanumeric, testDomainValidity}